export default __webpack_public_path__ + "static/media/profile.fdfb4ac3.svg";